import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
  withCredentials: true,
});

export const getEnhancementStatus = (id) => api.get(`/reports/${id}/enhancement_status`).then((r) => r.data);
export const generateReport = (payload) => api.post("/reports/generate", payload).then((r) => r.data);
export const listReports = () => api.get("/reports").then((r) => r.data);
export const getReport = (id) => api.get(`/reports/${id}`).then((r) => r.data);
export const getReportStatus = (id) => api.get(`/reports/${id}/status`).then((r) => r.data);
export const deleteReport = (id) => api.delete(`/reports/${id}`).then((r) => r.data);
export const updatePipeline = (id, payload) => api.patch(`/reports/${id}/pipeline`, payload).then((r) => r.data);
